import { Avatar, AvatarFallback, AvatarImage } from './avatar';

export interface User {
  id: string;
  name?: string;
  email?: string;
  image?: string | null;
  avatar?: string | null;
  firstname?: string;
  lastname?: string;
}

interface AvatarGroupProps {
  users: User[];
  limit?: number;
  className?: string;
}

export function AvatarGroup({ users, limit = 4, className = '' }: AvatarGroupProps) {
  const getInitials = (user: User) => {
    if (user.name) {
      return user.name
        .split(' ')
        .map((n) => n[0])
        .join('');
    }
    if (user.firstname || user.lastname) {
      return `${user.firstname?.[0] || ''}${user.lastname?.[0] || ''}`;
    }
    if (user.email) {
      return user.email[0].toUpperCase();
    }
    return 'U';
  };

  return (
    <div className={`flex items-center -space-x-2 *:ring *:ring-background ${className}`}>
      {users.slice(0, limit).map((user) => (
        <Avatar className="h-8 w-8 rounded-full" key={user.id}>
          <AvatarImage
            src={(user.avatar && user.avatar.trim()) || (user.image && user.image.trim()) || undefined}
            alt={user.name || `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.email || 'User'}
          />
          <AvatarFallback>{getInitials(user)}</AvatarFallback>
        </Avatar>
      ))}
      {users.length > limit && (
        <Avatar className="z-10 text-sm font-medium text-muted-foreground">
          <AvatarFallback>+{users.length - limit}</AvatarFallback>
        </Avatar>
      )}
    </div>
  );
}
